import { Button, Modal, Tooltip } from "antd"
const ConfirmResetModal = ({ resetModalOpen, handleResetModalClose, handleConfirmReset, buttonLoader, closeError, errorMessage }) => {
    return (
        <>
            <Modal
                open={resetModalOpen}
                onCancel={handleResetModalClose}
                title={'Are you sure?'}
                maskClosable={false}
                closeIcon={
                    <Tooltip title="Close">
                        <span className="icon close c-pointer" />
                    </Tooltip>
                }
                footer={
                    <><Button
                        type="primary"
                        className="cancel-btn"
                        onClick={handleResetModalClose}
                    >
                        Cancel
                    </Button>
                        <Button className='primary-btn !py-6' type="primary" htmlType="submit" loading={buttonLoader} onClick={handleConfirmReset}>
                            Confirm
                        </Button>
                    </>
                }
            >
                {errorMessage &&
                    <div className='mb-4'>
                        <Alert
                            className='mb-4'
                            type="error"
                            description={errorMessage}
                            onClose={closeError}
                            showIcon
                            closable
                        />
                    </div>}
                    <div className="">
                        <h1 className="text-whiteText font-medium text-base">Reset your authenticator key, as your authenticator app will not function until it is reconfigured.</h1>
                    </div>
            </Modal>
        </>
    )
}
export default ConfirmResetModal